/**
 * Pagination Info Component
 * Displays "Showing X-Y of Z items" information
 */

import React from 'react';
import { cn } from '@/lib/utils';
import { formatPaginationInfo } from '@/lib/pagination/utils';

interface PaginationInfoProps {
  currentPage: number;
  pageSize: number;
  totalCount: number;
  itemName?: string;
  className?: string;
}

export function PaginationInfo({
  currentPage,
  pageSize,
  totalCount,
  itemName = 'items',
  className,
}: PaginationInfoProps) {
  const info = formatPaginationInfo(currentPage, pageSize, totalCount, itemName);

  return <div className={cn('text-sm text-muted-foreground', className)}>{info}</div>;
}
